import React from "react";
import styles from "./Login.module.css";
import { Box, Button } from '@mui/material';

import AuroraImg from "../../assets/images/aurora.png"
import Header from "../../components/common/Header/Header";
import { useAuth } from "../../context/AuthProvider";

const Login = () => {
  const { OAuthLogin } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    OAuthLogin();
  };

  return (
    <div className={styles["page-container"]}>
      <Header page='login' />

      <main className={styles["content"]}>

        <div className={styles.loginCard}>
          <div className={styles.logoContainer}>
            <img src={AuroraImg} alt="Aurora showing logo" />
          </div>

          <h2 className={styles.title}>Welcome to Review Center</h2>

          <Box
            component="form" onSubmit={(e) => handleSubmit(e)}
            sx={{ width: '100%', maxWidth: '320px', margin: '0 auto' }}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 2,
                py: 1.5,
                color: '#ffffff',
                backgroundColor: '#00707E',
                textTransform: 'none',
              }}>
              Log in with MyYukon
            </Button>
          </Box>
        </div>
      </main>

    </div>
  );
};

export default Login;





